import { render, staticRenderFns } from "./Quickinfo.vue?vue&type=template&id=f9b58b2a&"
import script from "./Quickinfo.vue?vue&type=script&lang=js&"
export * from "./Quickinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports